import React from 'react';
import { invert } from 'lodash';
import { REQUEST_STATES } from 'state/requests/RequestStatusReducer';

export const CORE = 1;
export const PREFERRED = 2;
export const SELECT = 3;
export const PERSONAL_SERVICES = 4;
export const ENHANCED_PERSONAL_SERVICES = 5;

export const summitMembershipMap = {
  'General Services': CORE,
  'Preferred Services': PREFERRED,
  'Select Services': SELECT,
  'Personal Services': PERSONAL_SERVICES,
  'Enhanced Personal Services': ENHANCED_PERSONAL_SERVICES
};

export const summitMembershipMapById = invert(summitMembershipMap);

export const SELECT_MIN_AMOUNT = 250000;
export const PS_MIN_AMOUNT = 500000;
export const EPS_MIN_AMOUNT = 1000000;

export const hasReceivedHouseholdInformation = (requestStatus) => {
  return requestStatus.householdInformation === REQUEST_STATES.received;
};

export const tierTitle = (assetId) => {
  return (
    <div className="household-tier-name-title">
      <div className="household-tier-name-title-bolded">
        {summitMembershipMapById[assetId]}
      </div>{' '}
      Member
    </div>
  );
};

export const getProgressPercentage = (currentBalance, tierMaximumLimit) => {
  const percentage =
    currentBalance > 0 ? (currentBalance / tierMaximumLimit) * 100 : 0;
  return percentage > 100 ? 100 : percentage;
};

export const getBodyText = (assetId) => {
  switch (assetId) {
    case CORE:
      return 'Next Tier Benefit: Eligibility to invest in T. Rowe Price closed funds.';
    case SELECT:
      return 'Next Tier Benefit: Invest in lower-cost I Class shares ($50,000 minimum, per fund).';
    case PERSONAL_SERVICES:
      return 'Next Tier Benefit: Access investing, retirement, and personal finance events featuring T. Rowe Price experts.';
    case ENHANCED_PERSONAL_SERVICES:
      return '';
    default:
      return '';
  }
};
